export default __webpack_public_path__ + "static/media/switch-symbol.35e909be.png";